module.exports = __webpack_public_path__ + "static/media/heart-recognition-card.289f7021.svg";